import useSWR from "swr"
import { client } from "@lib/api"

type KYCBenefit = {
    kycLevel: string;
    kycLevelName: string;
    kycLevelStatus: KycLevelStatus;
    kycBenefitDetail: KycBenefitsDetail[];
};

type KycLevelStatus = {
    isActive: boolean;
    title: string;
    subTitle: string;
};
  
type KycBenefitsDetail = {
    title: string;
    value: number;
    unit: string;
};

type MappedBenefitsDetails = {
    title: string;
    value: number;
    unit: string;
    unitPosition: 'left' | 'right';
    isCurrency: boolean;
}

type MappedKYCLevelBenefit = {
    isActive: boolean;
    levelName: string;
    benefits: MappedBenefitsDetails[];
};

const useKYCBenefit = () => {
    const { data, isLoading, error } = useSWR(
        '/v2/wallet/kyc/benefits', 
        client.doGet,
        {
            dedupingInterval: 10000 // 10 seconds
        }
    )

    const mappedData: MappedKYCLevelBenefit[] = data?.map((item: KYCBenefit) => {
        return {
            isActive: item.kycLevelStatus.isActive,
            levelName: item.kycLevel,
            benefits: item.kycBenefitDetail.map((benefit: KycBenefitsDetail) => {
                return {
                    title: benefit.title,
                    value: benefit.unit === 'binary' ? Boolean(benefit.value) : benefit.value,
                    unit: benefit.unit,
                    unitPosition: benefit.unit === 'Rp' ? 'left' : 'right',
                    isCurrency: benefit.unit === 'Rp'
                }
            })
        }
    }) || []

    return {
        data: mappedData,
        isLoading,
        error
    }
}

export default useKYCBenefit
